import { useQuery } from '@tanstack/react-query';
import { getEscapedIssues } from '../services/AnalyticReportsService';
export default function useEscapedIssues(filters) {
    return useQuery(['escapedIssues', filters.values.dateRange], () => getEscapedIssues(filters), { staleTime: 5 * 60 * 1000, cacheTime: 30 * 60 * 1000 });
}
